<template>
    <a-card a-card title="Plugin Info" class="Custom--Card" :loading="loading">
        <a :href="plugin.homepage" target="_blank" v-html="plugin.name"></a><br><br>

        Total Download: {{ plugin.downloaded }}

        <br>Rating: <a-rate :value="(plugin.rating * 5) / 100" disabled /> ( {{ plugin.rating }} % )

        <div v-for="(rating, index) in plugin.ratings">
            {{ rating }} reviews <a-rate :value="parseInt(index)" disabled /><br>
        </div>
        Last updated: {{ plugin.last_updated }}
        Current version: {{ plugin.version }}
    </a-card>
</template>
<script>
import Api from "@/services/Api";

export default {
  name: 'PluginInfo',
  data: function (){
    return {
        loading: false,
        plugin: {},
    }
  },
  methods: {
      getDownloads() {
          this.loading = true;
          Api.get(`/reports/plugin_info`).then(res => {
              this.plugin = res.data;
              this.loading = false;
          }).catch(err => {
              this.$weNotify("error", "Failed to load data!");
              this.loading = false;
          })
      }
  },
  created() {
      this.getDownloads();
  }
}
</script>